import React from "react";
import emailjs from "@emailjs/browser";
import {
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import { useTranslation } from "react-i18next";

const ContactForm = () => {
  const { t } = useTranslation();

  const sendEmail = (e) => {
    e.preventDefault(); // Prevents the default form submission behavior

    emailjs
      .sendForm(
        "service_h1oaqyg", // Replace with your Service ID
        "template_u0pxfq2", // Replace with your Template ID
        e.target,
        "hwijPYhb2w3RSJQfu" // Replace with your Public Key
      )
      .then(
        (result) => {
          alert("Message Sent Successfully!");
          e.target.reset(); // Reset the form after success
        },
        (error) => {
          alert("Something went wrong, please try again.");
        }
      );
  };

  return (
    <Form className="contact-form" id="contactForm" onSubmit={sendEmail}>
      <Row>
        <Col md="6">
          <label>{t("contact.form.nameLabel")}</label>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="nc-icon nc-single-02" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              placeholder={t("contact.form.namePlaceholder")}
              type="text"
              name="user_name"
            />
          </InputGroup>
        </Col>
        <Col md="6">
          <label>{t("contact.form.emailLabel")}</label>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="nc-icon nc-email-85" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              placeholder={t("contact.form.emailPlaceholder")}
              type="email"
              name="user_email"
            />
          </InputGroup>
        </Col>
      </Row>
      <label>{t("contact.form.messageLabel")}</label>
      <Input
        placeholder={t("contact.form.messagePlaceholder")}
        type="textarea"
        rows="4"
        name="message" // Add name attribute
      />
      <Row>
        <Col className="ml-auto mr-auto" md="4">
          <Button className="btn-fill" color="secondary" size="lg" type="submit">
            {t("contact.form.submit")}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ContactForm;